import React from 'react';
import { Layout } from '../components/Layout';
import { Container } from '../components/ui/Container';
export function RefundPage() {
  return <Layout data-id="element-480">
      <div className="bg-slate-50 py-12 border-b border-slate-200" data-id="element-481">
        <Container data-id="element-482">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-483">
            Refund Policy
          </h1>
          <p className="text-slate-600" data-id="element-484">
            Last Updated: {new Date().toLocaleDateString()}
          </p>
        </Container>
      </div>

      <Container className="py-16 max-w-4xl" data-id="element-485">
        <div className="prose prose-slate max-w-none space-y-8" data-id="element-486">
          <section data-id="element-487">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-488">
              1. Nature of Digital Products and Services
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-489">
              DanyCredit LLC and Danycredit Academy offer digital educational
              products and consulting services, including but not limited to:
              masterclasses, online courses, recorded video content,
              downloadable materials, and personalized consulting sessions.
              These products and services are intangible digital goods that are
              consumed immediately upon access.
            </p>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-490">
              Due to the nature of digital content and the immediate access
              provided,{' '}
              <strong data-id="element-491">
                all sales are final once access has been granted or content has
                been accessed
              </strong>
              . This policy is consistent with industry standards for digital
              goods and is necessary to protect our intellectual property.
            </p>
            <div className="bg-red-50 border-l-4 border-red-600 p-4 my-6" data-id="element-492">
              <p className="text-sm text-red-900 font-bold mb-2" data-id="element-493">
                IMPORTANT: NO REFUNDS AFTER ACCESS
              </p>
              <p className="text-sm text-red-800 leading-relaxed" data-id="element-494">
                By purchasing any product or service from DanyCredit LLC or
                Danycredit Academy, you acknowledge and agree that refunds are
                NOT available once you have accessed the content, logged into
                the platform, downloaded any materials, or attended any
                consultation session.
              </p>
            </div>
          </section>

          <section data-id="element-495">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-496">
              2. Definition of "Access" and Point of No Return
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-497">
              For the purposes of this policy, "access" is defined as any of the
              following actions:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-498">
              <li data-id="element-499">
                <strong data-id="element-500">Login to Platform:</strong> The moment you receive login
                credentials and access the member area, course platform, or any
                restricted content area
              </li>
              <li data-id="element-501">
                <strong data-id="element-502">Content Viewing:</strong> Clicking on, streaming, or
                viewing any video, module, lesson, or educational material
              </li>
              <li data-id="element-503">
                <strong data-id="element-504">Download:</strong> Downloading any PDF, workbook,
                template, audio file, or other digital resource
              </li>
              <li data-id="element-505">
                <strong data-id="element-506">Consultation Attendance:</strong> Attending or joining
                any scheduled consultation, coaching call, or live session (even
                partially)
              </li>
              <li data-id="element-507">
                <strong data-id="element-508">Email Delivery:</strong> Receipt of course materials,
                access links, or digital deliverables via email
              </li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-509">
              <strong data-id="element-510">
                Once any of these actions occur, the purchase is considered
                fully delivered and consumed, and NO refund will be issued under
                any circumstances.
              </strong>
            </p>
          </section>

          <section data-id="element-511">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-512">
              3. No Right of Withdrawal for Digital Goods
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-513">
              Under applicable consumer protection laws, including but not
              limited to the EU Consumer Rights Directive and similar
              regulations in other jurisdictions, consumers typically have a
              right to withdraw from distance contracts within a specified
              period (e.g., 14 days).
            </p>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-514">
              <strong data-id="element-515">
                However, this right of withdrawal does NOT apply to digital
                content that has been delivered and accessed.
              </strong>{' '}
              By purchasing and accessing our digital products, you expressly
              acknowledge and agree that:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-516">
              <li data-id="element-517">
                You are purchasing intangible digital goods that are delivered
                immediately
              </li>
              <li data-id="element-518">
                You waive your right of withdrawal once access has been granted
              </li>
              <li data-id="element-519">
                The content begins to be performed/delivered immediately upon
                purchase
              </li>
              <li data-id="element-520">
                You understand that accessing the content constitutes full
                consumption of the product
              </li>
            </ul>
          </section>

          <section data-id="element-521">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-522">
              4. Non-Refundable Products and Services
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-523">
              The following are strictly NON-REFUNDABLE once accessed or
              delivered:
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-524">
              4.1 Digital Educational Products
            </h3>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-525">
              <li data-id="element-526">Masterclasses (recorded or live)</li>
              <li data-id="element-527">Online courses and training programs</li>
              <li data-id="element-528">Video lessons and modules</li>
              <li data-id="element-529">Downloadable PDFs, workbooks, templates, and guides</li>
              <li data-id="element-530">Audio recordings and podcasts</li>
              <li data-id="element-531">Access to member-only content or platforms</li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-532">
              4.2 Consulting and Advisory Services
            </h3>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-533">
              <li data-id="element-534">
                One-on-one consultation sessions (once attended, even partially)
              </li>
              <li data-id="element-535">Group coaching calls or webinars</li>
              <li data-id="element-536">Personalized credit analysis or financial reviews</li>
              <li data-id="element-537">Written reports, action plans, or strategy documents</li>
              <li data-id="element-538">Email or messaging support (once utilized)</li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-539">
              4.3 Subscription Services
            </h3>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-540">
              <li data-id="element-541">
                Monthly or recurring subscriptions (once the billing period has
                started and content has been accessed)
              </li>
              <li data-id="element-542">Membership programs (once access has been granted)</li>
            </ul>

            <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 mt-6" data-id="element-543">
              <p className="text-sm text-amber-900 font-bold mb-2" data-id="element-544">
                No Refunds Based on Results or Satisfaction
              </p>
              <p className="text-sm text-amber-800 leading-relaxed" data-id="element-545">
                We do NOT offer refunds based on dissatisfaction with content,
                personal results, credit score changes, financial outcomes, or
                any subjective measure of value. Our educational content is
                provided "as-is" for informational purposes, and individual
                results will vary.
              </p>
            </div>
          </section>

          <section data-id="element-546">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-547">
              5. Pre-Access Refund Window (Limited Exceptions)
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-548">
              A refund may ONLY be considered in the following extremely limited
              circumstances:
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-549">
              5.1 Before Access is Granted
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-550">
              If you have purchased a product or service but have NOT yet:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-551">
              <li data-id="element-552">Received login credentials or access links</li>
              <li data-id="element-553">Logged into the platform</li>
              <li data-id="element-554">Viewed any content</li>
              <li data-id="element-555">Downloaded any materials</li>
              <li data-id="element-556">Attended any scheduled session</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-557">
              You may request a refund within{' '}
              <strong data-id="element-558">24 hours of purchase</strong> by contacting
              info@danycredit.com. Refund requests must be made BEFORE any
              access is granted. Once credentials are sent or access is
              provided, this window closes immediately.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-559">
              5.2 Technical Issues (Our Fault Only)
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-560">
              A refund will ONLY be considered if there is a verified,
              unresolvable technical issue on our end that completely prevents
              you from accessing the content you purchased, AND:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-561">
              <li data-id="element-562">
                You have contacted our support team at info@danycredit.com
                within 48 hours of purchase
              </li>
              <li data-id="element-563">
                You have provided detailed information about the technical issue
              </li>
              <li data-id="element-564">
                Our technical team has attempted to resolve the issue and
                confirmed it is on our end
              </li>
              <li data-id="element-565">
                The issue cannot be resolved within a reasonable timeframe (7
                business days)
              </li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-566">
              <strong data-id="element-567">
                Technical issues on your end (internet connection, device
                compatibility, user error, etc.) do NOT qualify for a refund.
              </strong>
            </p>
          </section>

          <section data-id="element-568">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-569">
              6. Subscription and Recurring Billing
            </h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-570">
              6.1 Cancellation of Future Charges
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-571">
              For monthly or recurring subscription services, you may cancel at
              any time to prevent future charges. To cancel, email
              info@danycredit.com at least 48 hours before your next billing
              date.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-572">
              6.2 No Refunds for Current Billing Period
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-573">
              <strong data-id="element-574">
                Cancellation does NOT result in a refund for the current billing
                period.
              </strong>{' '}
              If you have accessed any content or services during the current
              billing cycle, that period is non-refundable. Your access will
              continue until the end of the paid period, after which no further
              charges will occur.
            </p>
          </section>

          <section data-id="element-575">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-576">
              7. Consultation Session Cancellations
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-577">
              For scheduled one-on-one consultation sessions:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-578">
              <li data-id="element-579">
                <strong data-id="element-580">More than 48 hours before session:</strong> Full refund
                or free rescheduling available
              </li>
              <li data-id="element-581">
                <strong data-id="element-582">24-48 hours before session:</strong> Rescheduling
                available; refund subject to 25% administrative fee
              </li>
              <li data-id="element-583">
                <strong data-id="element-584">Less than 24 hours before session:</strong> No refund;
                rescheduling subject to availability and 50% fee
              </li>
              <li data-id="element-585">
                <strong data-id="element-586">No-show or late cancellation:</strong> No refund; full
                session fee applies
              </li>
              <li data-id="element-587">
                <strong data-id="element-588">Session attended (even partially):</strong> No refund
                under any circumstances
              </li>
            </ul>
          </section>

          <section data-id="element-589">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-590">
              8. Refund Request Process
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-591">
              If you believe you qualify for a refund under the extremely
              limited circumstances outlined in Section 5, you must:
            </p>
            <ol className="list-decimal pl-6 text-slate-700 space-y-2 mb-4" data-id="element-592">
              <li data-id="element-593">Contact us immediately at info@danycredit.com</li>
              <li data-id="element-594">
                Provide your full name, purchase date, order number, and
                detailed explanation
              </li>
              <li data-id="element-595">Include proof of purchase (receipt or confirmation email)</li>
              <li data-id="element-596">
                If claiming a technical issue, provide screenshots, error
                messages, and device/browser information
              </li>
            </ol>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-597">
              We will review your request within 5-7 business days. If approved
              (which is rare and only under the conditions in Section 5),
              refunds will be processed within 10-14 business days to the
              original payment method.
            </p>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-598">
              <strong data-id="element-599">
                Refund requests that do not meet the criteria outlined in this
                policy will be denied.
              </strong>
            </p>
          </section>

          <section data-id="element-600">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-601">
              9. Chargebacks and Disputes
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-602">
              <strong data-id="element-603">
                Initiating a chargeback or payment dispute without first
                contacting us is considered a violation of these terms.
              </strong>
            </p>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-604">
              If you have a concern about a charge, you MUST contact us directly
              at info@danycredit.com before initiating any chargeback or dispute
              with your bank, credit card company, or payment processor
              (including Stripe).
            </p>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-605">
              We will provide full documentation to payment processors
              demonstrating that:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-606">
              <li data-id="element-607">Digital content was delivered as described</li>
              <li data-id="element-608">Access was granted and utilized</li>
              <li data-id="element-609">Terms were clearly communicated at time of purchase</li>
              <li data-id="element-610">This refund policy was accessible and agreed to</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-611">
              <strong data-id="element-612">Consequences of unauthorized chargebacks:</strong>
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-613">
              <li data-id="element-614">
                Immediate termination of access to all products and services
              </li>
              <li data-id="element-615">Permanent ban from future purchases</li>
              <li data-id="element-616">Legal action to recover costs and damages</li>
              <li data-id="element-617">Reporting to fraud prevention databases</li>
            </ul>
          </section>

          <section data-id="element-618">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-619">
              10. Intellectual Property Protection
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-620">
              All content provided by DanyCredit LLC and Danycredit Academy is
              protected by copyright and intellectual property laws. By
              purchasing, you receive a limited, non-transferable license to
              access and use the content for personal educational purposes only.
            </p>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-621">
              <strong data-id="element-622">
                Unauthorized distribution, sharing, reproduction, or resale of
                our content is strictly prohibited and will result in:
              </strong>
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-623">
              <li data-id="element-624">Immediate termination of access without refund</li>
              <li data-id="element-625">Legal action for copyright infringement</li>
              <li data-id="element-626">Pursuit of damages and legal fees</li>
            </ul>
          </section>

          <section data-id="element-627">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-628">
              11. Disclaimer of Results and Outcomes
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-629">
              DanyCredit LLC and Danycredit Academy provide educational content
              and consulting services for informational purposes only. We make
              NO guarantees, warranties, or representations regarding:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-630">
              <li data-id="element-631">Credit score improvements or increases</li>
              <li data-id="element-632">Loan or credit approvals</li>
              <li data-id="element-633">Financial outcomes or results</li>
              <li data-id="element-634">Removal of negative items from credit reports</li>
              <li data-id="element-635">Specific timeframes for achieving any goals</li>
              <li data-id="element-636">Suitability of content for your specific situation</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-637">
              <strong data-id="element-638">
                Individual results vary significantly based on personal
                circumstances, credit history, financial behavior, and actions
                taken.
              </strong>{' '}
              We are not responsible for your results or lack thereof.
            </p>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-639">
              We are NOT a credit repair organization, credit bureau, lender, or
              law firm. We do not provide legal, financial, or tax advice. You
              are solely responsible for your financial decisions.
            </p>
          </section>

          <section data-id="element-640">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-641">
              12. Modifications to This Policy
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-642">
              We reserve the right to modify this Refund Policy at any time
              without prior notice. Changes will be posted on our website with a
              new "Last Updated" date. Your continued use of our services after
              such changes constitutes acceptance of the updated policy.
            </p>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-643">
              The version of this policy in effect at the time of your purchase
              governs your transaction.
            </p>
          </section>

          <section data-id="element-644">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-645">
              13. Governing Law and Jurisdiction
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-646">
              This Refund Policy shall be governed by and construed in
              accordance with the laws of the State of Florida, United States,
              without regard to its conflict of law provisions.
            </p>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-647">
              Any disputes arising from or relating to this policy or refund
              requests shall be resolved exclusively in the state or federal
              courts located in Miami-Dade County, Florida. You consent to the
              exclusive jurisdiction of these courts.
            </p>
          </section>

          <section data-id="element-648">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-649">
              14. Contact Information
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-650">
              For questions about this Refund Policy or to request a refund
              under the limited circumstances outlined above, contact us:
            </p>
            <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 mt-4" data-id="element-651">
              <p className="font-semibold text-slate-900 mb-2" data-id="element-652">
                DanyCredit LLC / Danycredit Academy
              </p>
              <p className="text-slate-700" data-id="element-653">390 NE 191ST ST STE 8123</p>
              <p className="text-slate-700" data-id="element-654">Miami, FL 33179</p>
              <p className="text-slate-700" data-id="element-655">United States</p>
              <p className="text-slate-700 mt-3" data-id="element-656">Email: info@danycredit.com</p>
              <p className="text-slate-700" data-id="element-657">Phone: 786-376-3985</p>
              <p className="text-slate-700 mt-3 text-sm" data-id="element-658">
                Business Hours: Monday-Friday, 9am-6pm EST
              </p>
            </div>
          </section>

          <div className="bg-red-50 border-l-4 border-red-600 p-6 mt-8" data-id="element-659">
            <p className="text-sm text-red-900 font-bold mb-3" data-id="element-660">
              FINAL NOTICE: BY PURCHASING, YOU AGREE
            </p>
            <p className="text-sm text-red-800 leading-relaxed mb-2" data-id="element-661">
              By completing a purchase from DanyCredit LLC or Danycredit
              Academy, you acknowledge that you have read, understood, and agree
              to this Refund Policy in its entirety. You specifically
              acknowledge and agree that:
            </p>
            <ul className="list-disc pl-5 text-sm text-red-800 space-y-1 mb-3" data-id="element-662">
              <li data-id="element-663">
                All sales are final once access to digital content has been
                granted
              </li>
              <li data-id="element-664">
                You waive any right of withdrawal for digital goods once
                accessed
              </li>
              <li data-id="element-665">
                No refunds will be issued based on results, outcomes, or
                satisfaction
              </li>
              <li data-id="element-666">
                Refunds are only available under the extremely limited
                circumstances outlined in Section 5
              </li>
              <li data-id="element-667">Unauthorized chargebacks will result in legal action</li>
            </ul>
            <p className="text-sm text-red-800 leading-relaxed font-medium" data-id="element-668">
              This policy is designed to protect our intellectual property and
              is consistent with industry standards for digital educational
              products. If you do not agree with these terms, DO NOT complete
              your purchase.
            </p>
          </div>
        </div>
      </Container>
    </Layout>;
}